<template>
    <div class="select-event">
        <takeda-logo />

        <h2>Оберіть кімнату</h2>
        <div class="events">
            <div class="conference-item" v-for="(e, index) in $route.params.events" :key="index" @click="selectEvent(e.id)">
                {{e.name}}
            </div>
        </div>
    </div>
</template>

<script>
import TakedaLogo from '../../components/TakedaLogo';

export default {
    components : {
        'takeda-logo' : TakedaLogo
    },
    methods : {
        selectEvent(id){
            this.$store.commit('setEventId', id);
            this.$router.push('/create-patient');
        }
    }
}
</script>

<style lang="scss">
.select-event{
    width: 100%;
    height: 100%;

    background: url("../../assets/images/doctor/no-active-rooms-bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

     h2{
        margin: 0;

        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 28px;
        color: #575A5D;
    }

    .events{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        flex-wrap: wrap;

        width: calc(100% - 160px);

        padding: 45px 80px;

        .conference-item{
            cursor: pointer;

            margin-top: 45px;

            color: #ffffff;
            font-size: 18px;
            line-height: 28px;

            padding: 61px 20px;

            min-width: 25%;

            background: url("../../assets/images/doctor/room-bg.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;

            border-radius: 16px;
        }

        .conference-item:nth-child(1n){
            background-color: #00607E;
        }

        .conference-item:nth-child(2n){
            background-color: #B30037;
        }

        .conference-item:nth-child(3n){
            background-color: #F1A400;
        }
    }
}
</style>